<template>
  <Icons
    class="close-button"
    path="outline/x"
    size="24"
    alt="닫기"
    @click="$emit('click-close')"
  />
</template>
